/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { axiosInstance } from '../axiosInstance'
export const createUserAccountMapping = param => {
    try {

        return axiosInstance.post(`/api/gcadmin/v1/user/mapping/createUserAccountMapping`, param).then(res => res.data);
    } catch (error) {
        throw error;
    }
}
export const getAccountMappingHistory = param => {
    try {
        return axiosInstance.post(`/api/gcadmin/v1/user/mapping/get-account-mapping-history`, param).then(res => res.data);

    } catch (error) {
        throw error;
    }
}
export const getAccountMappingByID = param => {
    try {

        return axiosInstance.post(`/api/gcadmin/v1/user/mapping/getAccountMappingByID`, param).then(res => res.data);
    } catch (error) {
        throw error;
    }
}
export const getAccountMappingForUserID = param => {
    try {

        return axiosInstance.post(`/api/gcadmin/v1/user/mapping/getAccountMappingForUserID`, param).then(res => res.data);
    } catch (error) {
        throw error;
    }
}
export const getAllAccountMappings = param => {
    try {

        return axiosInstance.post(`/api/gcadmin/v1/user/mapping/getAllAccountMappings`, param).then(res => res.data);
    } catch (error) {
        throw error;
    }
}
export const updatingAccountMappings = param => {
    try {

        return axiosInstance.post(`/api/gcadmin/v1/user/mapping/updatingAccountMappings`, param).then(res => res.data);
    } catch (error) {
        throw error;
    }
}